import { writable } from "svelte/store";

export const handlingCollectionId = writable<string | undefined>(undefined)
export const handlingMulitpleStoreItem = writable<boolean>(false)